import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, MailIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
import { SectionHeading } from './SectionHeading';
export function FinalCtaSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg)] py-16 sm:py-20" data-id="element-71" data-mp="3qrosjgds4fwr">
      <div className="mx-auto max-w-6xl px-4" data-id="element-72" data-mp="3vrulr0zp6agy">
        <SectionHeading eyebrow="⏰ El precio especial cierra en:" data-id="element-73" data-mp="2y5drk4m9gczf">
          Elegí tu plan ahora
        </SectionHeading>

        <div className="mt-8" data-id="element-74" data-mp="334qfksovbq3l">
          <Countdown compact data-id="element-75" data-mp="331uif6kuh5g7" />
        </div>

        <div className="mt-12" data-id="element-76" data-mp="382rxhaak5jdh">
          <PricingCards compact data-id="element-77" data-mp="381gvng0oalp0" />
        </div>

        <div className="mx-auto mt-12 max-w-2xl rounded-2xl border border-[var(--line)] bg-[var(--surface)] p-6 text-center" data-id="element-78" data-mp="3cti38omwbo8p">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[var(--rose)]" data-id="element-79" data-mp="2fdb8ynq26mmj">
            100% seguro
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-[var(--text-soft)]" data-id="element-80" data-mp="2kbmjz1s3b36c">
            <span className="inline-flex items-center gap-1.5" data-id="element-81" data-mp="28cx7387z14sy">
              <LockIcon className="h-4 w-4 text-[var(--slate)]" aria-hidden="true" data-id="element-82" data-mp="28dfbis4sepby" />
              Mercado Pago · Tarjeta · Transferencia
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-83" data-mp="1ynnelr97tk4b">
              <ZapIcon className="h-4 w-4 text-[var(--slate)]" aria-hidden="true" data-id="element-84" data-mp="1yl15hn6oewjz" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-85" data-mp="1plw9oomi1hbi">
              <ShieldCheckIcon className="h-4 w-4 text-[var(--slate)]" aria-hidden="true" data-id="element-86" data-mp="1pos9kihwqg2l" />
              Garantía 7 días
            </span>
          </div>
          <a href="mailto:soportetuplataformadigital@gmail.com" className="mt-4 inline-flex items-center gap-2 text-sm text-[var(--text)] underline decoration-[var(--rose)]/60 underline-offset-4 transition-colors duration-150 ease-out hover:text-[var(--rose)]" data-id="element-87" data-mp="1fpb1juf6nq3g">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="18c239cdywm5n" />
            soportetuplataformadigital@gmail.com
          </a>
        </div>
      </div>
    </section>;
}